import { jsx as _jsx } from "react/jsx-runtime";
import { strictLocalize } from "@faire/web--source/common/localization";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import React from "react";
export var getInsiderTestimonials = function(showLocation) {
    return [
        {
            text: strictLocalize({
                id: "5N0Yid",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u201CInsider is incredibly cost effective. We love not having to pay shipping and import duties fees, which allows us to pass our savings on to our clients.\u201D"
                    }
                ]
            }),
            name: "Funmi Wilkes",
            info: showLocation ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "7Ivflt",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Owner, Conscious Craft"
                    },
                    {
                        type: 8,
                        value: "LineBreakFormatting",
                        children: []
                    },
                    {
                        type: 0,
                        value: "East Sussex, UK"
                    }
                ],
                values: {
                    LineBreakFormatting: function() {
                        return /*#__PURE__*/ _jsx("br", {});
                    }
                }
            }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "jwhQ0x",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Owner, Conscious Craft"
                    }
                ]
            }),
            imageUrl: "https://cdn.faire.com/fastly/b0b62de38345bf9d718f331da646b413aa28b6796b7d13a8398672e0af3d30aa.png"
        },
        {
            text: strictLocalize({
                id: "towwxD",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u201CInsider takes the stress out of ordering from brands outside the UK. The program's free shipping & import duties have allowed us to add so many amazing new brands to our product collection for our customers.\u201D"
                    }
                ]
            }),
            name: "Katharine Diggins-Barnes",
            info: showLocation ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "UvZSh4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Owner, Love From Betty"
                    },
                    {
                        type: 8,
                        value: "LineBreakFormatting",
                        children: []
                    },
                    {
                        type: 0,
                        value: "Camberley, Surrey, UK"
                    }
                ],
                values: {
                    LineBreakFormatting: function() {
                        return /*#__PURE__*/ _jsx("br", {});
                    }
                }
            }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "JzO5wh",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Owner, Love From Betty"
                    }
                ]
            }),
            imageUrl: "https://cdn.faire.com/fastly/5c434bca3ac55eccbab68a58e4691d2599b8c5db9ef2abd0a9f21c6bfd944f3d.png"
        },
        {
            text: strictLocalize({
                id: "HBB6Zd",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u201CWith the Insider program, we have saved so much in costs that have definitely boosted our margins on these products.\u201D"
                    }
                ]
            }),
            name: "Kim Rait",
            info: showLocation ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "7h6dCW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Company Director, Black Orchid"
                    },
                    {
                        type: 8,
                        value: "LineBreakFormatting",
                        children: []
                    },
                    {
                        type: 0,
                        value: "Alness, UK"
                    }
                ],
                values: {
                    LineBreakFormatting: function() {
                        return /*#__PURE__*/ _jsx("br", {});
                    }
                }
            }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "ckAyo8",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Company Director, Black Orchid"
                    }
                ]
            }),
            imageUrl: "https://cdn.faire.com/fastly/87f1cc9d6085c7033833d5c2b5bc472f9f499df1e2bcae6716e8f30d959316f9.png"
        }
    ];
};
export var getUSInsiderTestimonials = function() {
    return [
        {
            text: strictLocalize({
                id: "v4SMns",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u201CThe free shipping makes all the difference! It really helps our bottom line as a small business!\u201D"
                    }
                ]
            }),
            name: "Allison Holley",
            info: /*#__PURE__*/ _jsx(InsiderOwnerTestimonialSignature, {
                retailerCompanyName: "Apple & Oak"
            }),
            imageUrl: "https://cdn.faire.com/fastly/0d60785f3dcbe87c7651fed684dd2910e27220c77d11975820407841fcbf1bb5.png"
        },
        {
            text: strictLocalize({
                id: "x4ZE+P",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u201CWe rely on our Insider access to new vendors to find unique products for our shops.\u201D"
                    }
                ]
            }),
            name: "Chris Holmes",
            info: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "d0Mamj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Owner, Deep South Mercantile"
                    }
                ]
            }),
            imageUrl: "https://cdn.faire.com/fastly/020a3ac995d4f739990a627a86662428a22b2a7332c11e2c3c1dea8c37c7ba70.png"
        },
        {
            text: strictLocalize({
                id: "vJPg70",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u201CThe Insider program is worth every penny!\u201D"
                    }
                ]
            }),
            name: "Elizabeth Stutzman",
            info: /*#__PURE__*/ _jsx(InsiderOwnerTestimonialSignature, {
                retailerCompanyName: "Green Velvet"
            }),
            imageUrl: "https://cdn.faire.com/fastly/1f843a551d54251c637c7b341361eaa3d676fc2f0748d699bd289ae7c8446117.png"
        },
        {
            text: strictLocalize({
                id: "q8yvu0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u201CHaving the Insider Membership free shipping from so many vendors has paid for itself many times over.\u201D"
                    }
                ]
            }),
            name: "Erica Becker Morin",
            info: /*#__PURE__*/ _jsx(InsiderOwnerTestimonialSignature, {
                retailerCompanyName: "Provocatrix Designs"
            }),
            imageUrl: "https://cdn.faire.com/fastly/b33ea2f7d92f81dc96eba4b63ab81c73d8f64806e8cf29d3cd2b56b2151964e8.png"
        },
        {
            text: strictLocalize({
                id: "fEe0uu",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u201CWe have taken advantage of seeing the new vendors before everyone else. It's a great program that truly makes a difference.\u201D"
                    }
                ]
            }),
            name: "Barbara Pugliese",
            info: /*#__PURE__*/ _jsx(InsiderOwnerTestimonialSignature, {
                retailerCompanyName: "Just/Because"
            }),
            imageUrl: "https://cdn.faire.com/fastly/46c8efa464f438ea5c0de7376cb4cb71777daf5f5712b8b2eb2921619f5edd5b.png"
        }
    ];
};
var InsiderOwnerTestimonialSignature = function(param) {
    var retailerCompanyName = param.retailerCompanyName;
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "0EBIJ2",
        defaultMessage: [
            {
                type: 0,
                value: "Owner, "
            },
            {
                type: 1,
                value: "retailerCompanyName"
            }
        ],
        values: {
            retailerCompanyName: retailerCompanyName
        }
    });
};
export var RejoinInsiderMsg = function() {
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "X1xjwh",
        defaultMessage: [
            {
                type: 0,
                value: "Rejoin Insider"
            }
        ]
    });
};
export var AVERAGE_SHIPPING_COSTS = IFaireMoney.build({
    amount_cents: 6900,
    currency: "USD"
});
export var INSIDER_MONTHLY_MEMBERSHIP_COST = IFaireMoney.build({
    amount_cents: -1999,
    currency: "USD"
});
export var INSIDER_ANNUAL_MEMBERSHIP_COST = IFaireMoney.build({
    amount_cents: -1799,
    currency: "USD"
});
export var INSIDER_MONTHLY_MEMBERSHIP_SAVINGS = IFaireMoney.build({
    amount_cents: 4900,
    currency: "USD"
});
export var INSIDER_ANNUAL_MEMBERSHIP_SAVINGS = IFaireMoney.build({
    amount_cents: 5100,
    currency: "USD"
});
